import { jsx as _jsx } from "react/jsx-runtime";
import ErrorAlert from "../components/ErrorAlert.js";
import { STANDARD_SPACING } from "../config.js";
export default function FormUniversalError(props) {
    if (!props.form.hasSelfErrors) {
        return null;
    }
    return _jsx(ErrorAlert, { children: props.form.selfErrors?.map(_ => _.message).join(", "), className: "mb-" + STANDARD_SPACING });
}
